import { ComponentsOverrides, Theme } from "@mui/material";

const muiSvgIcon = (): ComponentsOverrides<Theme>["MuiSvgIcon"] => ({
  fontSizeMedium: {
    fontSize: "1.6rem",
  },
});

export default muiSvgIcon;
